module.exports = __webpack_public_path__ + "img/powered-by-akash-dark.43571c05.svg";